import { Input } from '@heroui/react';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormControlProps } from '../types/form-props.type.ts';
import { StateSelect } from './state-select.tsx';

const AddressForm: FC<FormControlProps> = ({ name, disabled, required }) => {
  const { control } = useFormContext();

  const validateLine1 = (value: string, formValues: any) => {
    const hasOtherFields =
      formValues[name]?.city || formValues[name]?.state?.id || formValues[name]?.zipCode;
    if (hasOtherFields && !value) {
      return 'Must be a complete address';
    }
    return true;
  };

  const validateCity = (value: string, formValues: any) => {
    const hasOtherFields =
      formValues[name]?.line1 || formValues[name]?.state?.id || formValues[name]?.zipCode;
    if (hasOtherFields && !value) {
      return 'Must be a complete address';
    }
    return true;
  };

  const validateZipCode = (value: string, formValues: any) => {
    const hasOtherFields =
      formValues[name]?.line1 || formValues[name]?.city || formValues[name]?.state?.id;
    if (hasOtherFields && !value) {
      return 'Must be a complete address';
    }
    return true;
  };

  const validateState = (value: any, formValues: any) => {
    const hasOtherFields =
      formValues[name]?.line1 || formValues[name]?.city || formValues[name]?.zipCode;
    if (hasOtherFields && !value?.id) {
      return 'Must be a complete address';
    }
    return undefined;
  };

  return (
    <>
      <Controller
        name={`${name}.line1`}
        control={control}
        rules={{
          required: required ? 'This field is required' : undefined,
          validate: validateLine1,
        }}
        render={({ field, fieldState }) => (
          <Input
            {...field}
            label='Address'
            variant='bordered'
            isRequired={required}
            isDisabled={disabled}
            isInvalid={fieldState.invalid}
            errorMessage={fieldState.error?.message}
          />
        )}
      />
      <Controller
        name={`${name}.line2`}
        control={control}
        render={({ field, fieldState }) => (
          <Input
            {...field}
            variant='bordered'
            label='Address 2'
            isDisabled={disabled}
            isInvalid={fieldState.invalid}
            errorMessage={fieldState.error?.message}
          />
        )}
      />
      <div className='grid grid-cols-3 gap-2'>
        <Controller
          name={`${name}.city`}
          control={control}
          rules={{
            required: required ? 'This field is required' : undefined,
            validate: validateCity,
          }}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              label='City'
              variant='bordered'
              isRequired={required}
              isDisabled={disabled}
              isInvalid={fieldState.invalid}
              errorMessage={fieldState.error?.message}
            />
          )}
        />
        <StateSelect
          name={`${name}.state`}
          required={required}
          disabled={disabled}
          validatorFn={validateState}
        />
        <Controller
          name={`${name}.zipCode`}
          control={control}
          rules={{
            required: required ? 'This field is required' : undefined,
            validate: validateZipCode,
          }}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              label='Zip'
              variant='bordered'
              isRequired={required}
              isDisabled={disabled}
              isInvalid={fieldState.invalid}
              errorMessage={fieldState.error?.message}
            />
          )}
        />
      </div>
    </>
  );
};

export default AddressForm;
